module.exports = __webpack_public_path__ + "static/media/icon-sucess.5399f72f.svg";